<template>
  <div class="findpage" :class="{'hashead':!isPC}">
    <LeaveTel ref=LeaveTel :isFind="showLeave" @setIsFind="getIsFind"  :isShowXy="isShowXy" @setIsShowXy="getIsShowXy"></LeaveTel>
    <Header v-if="isPC"></Header>
    <WapHeader v-if="!isPC" :title="'帮我找房'" :showhome="false"></WapHeader>
    <div class="banner">
      <p><b>帮你找到心仪房源</b>输入您的找房需求，精准帮你找到优质房源</p>
    </div>
    <div class="box">
      <div class="queswrap">
        <p class="qtitle">1、您的买房总预算： <span>{{q1value[0]}}0-{{q1value[1]}}0万</span></p>
        <el-slider class="slider" v-model="q1value" range :marks="marks" :step="step" :min="min" :show-tooltip="showtooltip">
        </el-slider>
        <p class="qtitle">2、您想要的户型是？</p>
        <div class="checkbox clearfix">
          <span v-for="(item,index) in hxItem" :key="index" :class="{'active':hxvalue==item.name}" @click="hxClick(item.name)">{{item.name}}</span>
        </div>
        <p class="qtitle">3、建筑面积不小于？</p>
        <div class="checkbox clearfix">
          <span v-for="(item,index) in mjItem" :key="index" :class="{'active':mjvalue==item.name}" @click="mjClick(item.name)">{{item.name}}㎡</span>
          <span @click="mjClick('')" :class="{'active':mjvalue==''}">没要求</span>
        </div>
        <p class="qtitle">4、您倾向的房源地段是？（可多选）</p>
        <div class="checkbox clearfix">
          <span v-for="(item,index) in ddItem" :key="index" :class="{'active':ddvalue.indexOf(item.name)!=-1}" @click="ddClick(item.name)">{{item.name}}</span>
          <span @click="ddClick('')" :class="{'active':ddvalue.length==0}">没要求</span>
        </div>

        <div class="inputwrap boxshadow">
          <p class="qtitle t">您的联系方式是？</p>

          <div class="inputbox"><input type="tel" v-model="phone" placeholder="请输入手机号"></div>
          <p class="error" v-show="isPhoneError" >请输入正确的手机号码</p>
          <div class="inputbox"><input type="text" placeholder="请输入验证码" v-model="code">
            <span v-show="codeShow"  class="codeBtn"  @click="getCode()">获取验证码</span>
            <span v-show="!codeShow" class="codeBtn gray">{{count}}s</span>
          </div>
          <p class="error" v-show="isCodeError" >{{errorMsg}}</p>
          <p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
          <a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
          <a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《素旭用户协议》</a>
          (点击可取消)</p>
          <p class="error" v-show="isXyError" >请阅读并勾选用户协议</p>
          <p class="mbutton" @click="okClick()">立即提交</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import LeaveTel from '@/components/public/LeaveTel'
import Footer from '@/components/public/Footer'
export default {
  name: 'FindHouse',
  components:{
    'Header': Header,
    'WapHeader':WapHeader,
    'LeaveTel':LeaveTel,
    'Footer': Footer,
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      filterItems:[],
      q1value:[1,30],
      showtooltip:false,
      step:1,
      min:1,
      marks:{
        1:'10万',
        100:'1000万+'
      },
      hxItem:[
        {name:'一室',id:'1'},
        {name:'两室',id:'2'},
        {name:'三室',id:'3'},
        {name:'四室',id:'4'},
        {name:'五室',id:'5'},
        {name:'无所谓',id:''},
      ],
      codeShow:true,
      count: '',
      timer: null,
      hxvalue:'',
      mjItem:[],
      mjvalue:'',
      ddItem:[],
      ddvalue:[],
      tsItem:[],
      tsvalue:[],
      showLeave:false,
      isFind:false,
      phone:'',
      code:null,
      isPhoneError:false,
      isCodeError:false,
      isXyError:false,
      errorMsg:'请输入验证码',
      isCheck:false,
      showXY:false,
      isShowXy:false
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    var _this = this;
    _this.getDist();
  },
  methods:{
    changeCheck(){
      this.isCheck=!this.isCheck;
    },
    getIsShowXy(data){
      this.isShowXy = data;
    },
    getIsFind:function(data){
      // this.showLeave = data;
      if(data && data != null){
        this.isCodeError = true;
        this.errorMsg = data;
      }
    },
    getDist:function(){
      this.$http.get('/api/estateSearch/getLocationParams?locationId='+this.storage.get('city').citySite).then((response)=>{
        this.ddItem = response.data.result.locationList;
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getPurchaseParams').then((response)=>{
        this.tsItem = response.data.result.tagAllList;
        this.mjItem = response.data.result.areaList;
      }).catch((response)=>{
        console.log(response)
      })
    },
    hxClick:function(id){
      this.hxvalue=id;
    },
    mjClick:function(id){
      this.mjvalue=id;
    },
    ddClick:function(id){
      if(id==''){
        this.ddvalue=[];
      }else{
        if(this.ddvalue.indexOf(id)!=-1){
          this.ddvalue.splice(this.ddvalue.indexOf(id),1)
        }else{
          this.ddvalue.push(id)
        }
      }
    },
    tsClick:function(id){
      if(this.tsvalue.indexOf(id)!=-1){
        this.tsvalue.splice(this.tsvalue.indexOf(id),1)
      }else{
        this.tsvalue.push(id)
      }
    },
    getCode: function(){
      //校验手机号码
      if(!this.$refs.LeaveTel.checkPhone(this.phone)){
        this.isPhoneError =true;
        return false;
      }
      this.isPhoneError =false;
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.codeShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              } else {
              this.codeShow = true;
              clearInterval(this.timer);
              this.timer = null;
              }
            }, 1000)
          }
      //获取验证码
      this.$http.get('/api/user/getSmscode?mobile='+this.phone).then((response)=>{
        if(response.data.result && !response.data.result.resultCode && response.data.result.msg!=null){
          this.isCodeError = true;
          this.errorMsg =  response.data.result.msg;
        }else{
          this.isCodeError = false;
          this.errorMsg = '';
        }
        console.log(response);
      }).catch((response)=>{
        console.log(response)
      })
    },
    okClick:function(){
      var data = '预算:['+this.q1value[0]+'0_'+this.q1value[1]+'0' + ' 万] 户型:['+this.hxvalue+'] 面积:['+this.mjvalue+'] 地段:['+this.ddvalue+'] 标签:['+this.tsvalue+'] 手机:['+this.phone;

      if(this.isCheck!=true){
        this.isXyError= true;
        return false;
      }
      this.isXyError= false;

      //校验手机号码
      if(!this.$refs.LeaveTel.checkPhone(this.phone)){
        this.isPhoneError =true;
        return false;
      }
      this.isPhoneError =false;

      if(this.code==null || this.code==''){
        this.isCodeError =true;
        return false;
      }

      //校验验证码
      this.$http.get('/api/user/checkSmsCode?mobile='+this.phone+'&smsCode='+this.code).then((response)=>{
        console.log(response);
        if(!response.data.result){
          this.isCodeError = true;
          this.errorMsg = '验证码错误';
          return false;
        }
        this.isCodeError = false;
        this.errorMsg = '请输入验证码';

      //如果是从新盘热推界面过来的，需要取到新盘热推主题ID
      var projectPkId = this.$route.query.id!=null?this.$route.query.id:'';


        this.$refs.LeaveTel.setParams(22,null,null,'帮我找房',projectPkId,data,this.phone);
        this.$refs.LeaveTel.sendFromInLine();
        this.showLeave=true;

        //清空
        this.phone ='';
        this.code = ''

      }).catch((response)=>{
        console.log(response)
          this.isCodeError = true;
          this.errorMsg = '验证码错误';
          return false;
      })
    },
  }
}
</script>

<style scoped>
  .banner{height:130px;background:url(../assets/images/findbg.png) no-repeat;background-size:cover;display:table;width:100%;}
  .banner p{color:#fff;text-align:center;line-height:20px;padding:0 20px;display:table-cell;vertical-align:middle;}
  .banner b{display:block;font-size:18px;font-weight:700;line-height:36px;position:relative;margin-bottom:5px;}
  .banner b:after{content:"";position:absolute;bottom:0;left:50%;width:20px;height:2px;background:#ffd03d;margin-left:-10px;}
  .queswrap{padding:0 15px 20px;background:#fff;}
  .error{color:#F44336;font-size:12px;text-align:left;padding-top:5px;padding-left:10px;}
  .qtitle{color:#2e303a;padding-top:20px;line-height:20px;font-size:15px;}
  .qtitle.t{padding-left:10px;}
  .qtitle span{color:#F44336;}
  .slider{padding:5px 20px 0;height:55px;position:relative;z-index:0;}
  /*.checkbox{padding:0 0 0 15px;}*/
  .xy{padding-left:10px;}
  .checkbox span{float:left;background:#eee;color:#888;text-align:center;font-size:13px;border-radius:4px;line-height:34px;margin-top:10px;padding:1px 10px 0;margin-right:10px;cursor:pointer;min-width:60px;}
  .checkbox span.active{background:#ffd03d;color:#2e303a;}
  .inputbox{position:relative;border-bottom:1px solid #ccc;padding:15px 0 10px;margin:0 10px;}
  .inputbox input{display:block;width:100%;border:0;background:none;outline:0;height:20px;line-height:20px;font-size:14px;}
  .inputbox span{position:absolute;right:0;top:15px;line-height:20px;}
  .mbutton{width:200px;margin:20px auto 10px;}
  .codeBtn{cursor:pointer;}
  .gray{color:#888;}
  .findpage >>> .el-slider__runway{height:4px;background-color:#e9e9e9;}
  .findpage >>> .el-slider__marks-text{color:#2e303a;font-size:13px;white-space:nowrap;margin-top:20px;transform:translateX(-40px);}
  .findpage >>> .el-slider__marks-text:first-child{transform:translateX(-10px);}
  .findpage >>> .el-slider__bar{height:4px;background-color:#ffd03d;}
  .findpage >>> .el-slider__button{background-color:#ffd03d;border:3px solid #fff;box-shadow:0 3px 5px #ddd;}
  .findpage >>> .el-slider__stop{display:none;}

  @media (min-width:320px) and (max-width:413px){
    .checkbox span{width:30%;margin-right:3%;padding-left:0;padding-right:0;}
  }
  @media (min-width:414px) and (max-width:500px) {
    .checkbox span{width:22%;margin-right:3%;padding-left:0;padding-right:0;}
  }
  @media (min-width:769px){
    .banner{height:150px;}
    .queswrap{position:relative;padding:0 360px 30px 2%}
    .inputwrap{position:absolute;right:2%;top:40px;width:260px;padding:0 20px 20px;}
    .qtitle{font-size:16px;padding-top:35px;padding-bottom:10px;font-weight:700;}
    .checkbox span{line-height:32px;padding:0 12px;}
  }
  @media (min-width:900px){
    .queswrap{padding:0 400px 40px 3%;}
    .inputwrap{right:3%;width:270px;padding:0 25px 25px;}
  }
  @media (min-width:1000px){
    .queswrap{padding:10px 460px 50px 5%;}
    .inputwrap{right:5%;top:50px;width:280px;padding:0 30px 30px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/FindHouse.vue